import PatientFile from "@/components/practitioner/PatientFile";

export interface LocationState {
  firstName: string;
  lastName: string;
  patientId: number
}

export default function PatientFiles () {

  return (
    <div>
      <PatientFile />
    </div>
  );
}
